import { renderAsync } from "docx-preview";
import { PropsWithChildren, ReactElement, useEffect, useRef } from "react";
import { RendererProps } from "./types";

export function DocxRenderer({
	url,
	children,
}: PropsWithChildren<RendererProps>): ReactElement {
	const containerRef = useRef<HTMLDivElement>(null);

	useEffect(() => {
		const loadDocument = async (): Promise<void> => {
			try {
				const response = await fetch(url);
				const blob = await response.blob();

				if (containerRef.current) {
					renderAsync(blob, containerRef.current).catch((error) => {
						// TODO: handle error
					});
				}
			} catch (error) {
				// TODO: handle error
			}
		};

		loadDocument().catch((error) => {
			// TODO: handle error
		});
	}, [url]);

	return (
		<div className="flex h-[calc(90vh-100px)] items-center justify-center">
			<div
				className="h-full w-full overflow-auto rounded-md bg-white"
				ref={containerRef}
			/>
			{children}
		</div>
	);
}
